/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useState, useContext } from 'react'
import {
  getApiTargetInfo,
  getValidYearRange,
  isValidYearRange,
  UnitSelection,
} from 'core'
import { connect } from 'react-redux'
import { CriteriaRow, Title, Content } from 'core/screen-util'
import { DatePicker, Button, message } from 'antd'
import { postGenerationRequest, postFuelRequest } from 'api/pgads'
import { SpinContext, ErrorContext, UnitSelectionContext } from 'context'
import moment from 'moment'
import JcTmpErrorDialog from 'core/component/JcTmpErrorDialog'

const RequestData = props => {
  const { apiTargetInfo } = props
  const { setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  const { selectedUnits } = useContext(UnitSelectionContext)
  const [genRes, setGenRes] = useState([])

  // const { selectedDateRangePicker, setSelectedDateRagePicker } = useContext(
  //   DatePickerContext
  // )
  // const callGenerationCall = ({})=>{

  // }

  const [dateRange, setDateRange] = useState([moment(), moment()])
  const [monthSel, setMonthSel] = useState(moment())

  const generateRequest = _ => {
    const isValid = isValidYearRange(
      props.validYearRange,
      dateRange[0],
      dateRange[1]
    )
    if (!isValid) return
    if (selectedUnits.length <= 0) {
      message.error('Please, Select Unit')
      return
    }
    setSpinning(true)
    postGenerationRequest(apiTargetInfo)({
      units: selectedUnits,
      startDate: dateRange[0],
      endDate: dateRange[1],
    }).fork(setError, data => {
      setSpinning(false)
      // if (
      //   data.find(
      //     d => d.errorMessage && d.errorMessage.includes('UnknownHostException')
      //   )
      // )
      //   message.error(' Service Not Working : UnknownHostException')
      // else
      setGenRes(data)
    })
  }

  const fuelRequest = _ => {
    if (selectedUnits.length <= 0) {
      message.error('Please, Select Unit')
      return
    }
    setSpinning(true)
    postFuelRequest(apiTargetInfo)({
      units: selectedUnits,
      year: monthSel.format('YYYY'),
      month: monthSel.format('MM'),
    }).fork(setError, data => {
      setSpinning(false)
      setGenRes(data)
    })
  }

  return (
    <div
      css={{
        backgroundColor: '#f0f2f5',
        marginLeft: '20px',
        marginRight: '20px',
      }}
    >
      <JcTmpErrorDialog
        // title="Error"
        visible={genRes.length > 0}
        errors={genRes}
        closeErrorPrompt={_ => setGenRes([])}
      />
      <UnitSelection />
      <CriteriaRow>
        <Title
          style={{
            marginRight: '15px',
            marginBottom: '5px',
          }}
        >
          Request Data
        </Title>
      </CriteriaRow>
      <Content>
        <fieldset>
          <legend>Generation</legend>
          <DatePicker.RangePicker
            allowClear={false}
            format="MM/DD/YYYY"
            // mode={['month', 'month']}
            // mode="decade"
            value={dateRange}
            // placeholder={['Start month', 'End month']}
            // open={openPicker}
            onChange={dates => {
              setDateRange(dates)
            }}
            onPanelChange={dates => {
              setDateRange(dates)
            }}
          />
          <Button
            onClick={generateRequest}
            type="primary"
            style={{ marginLeft: '20px' }}
            icon="database"
          >
            Generation Request
          </Button>
        </fieldset>
      </Content>
      <Content>
        <fieldset>
          <legend>Fuel</legend>
          <DatePicker.MonthPicker
            allowClear={false}
            // mode={['month']}
            // mode="decade"
            format="MMMM-YYYY"
            value={monthSel}
            // open={openPicker}
            onChange={dates => {
              setMonthSel(dates)
            }}
            onPanelChange={dates => {
              setMonthSel(dates)
            }}
          />
          <Button
            onClick={fuelRequest}
            type="primary"
            style={{ marginLeft: '20px' }}
            icon="database"
          >
            Fuel Request
          </Button>
        </fieldset>
      </Content>
    </div>
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  validYearRange: getValidYearRange(state),
})

export default connect(mapStateToProps)(RequestData)
